import React, { useEffect, useState } from "react";
import "./RolesAndPermissions.css";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import axios from "axios";
import jwt_decode from "jwt-decode";
import close from "../../../../assets/icons/close.png";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import LoadingView from "../../../components/LoadingView/LoadingView.js";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const RolesAndPermissions = () => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [userId, setUserId] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const [roleIds, setRoleIds] = useState([]);
  const [users, setUsers] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [screens, setScreens] = useState([]);
  const [functions, setFunctions] = useState([]);

  const [selectedRole, setSelectedRole] = useState("None");
  const [selectedUser, setSelectedUser] = useState("None");
  const [role, setRole] = useState({});

  const [restaurantList, setRestaurantList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [screenList, setScreenList] = useState([]);
  const [functionList, setFunctionList] = useState([]);
  const [roleObj, setRoleObj] = useState(null);
  const [loading, setLoading] = useState(false);
  console.log("roles: ", roleIds);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getAllRolesData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllUsersRole?userId=${userId}`,
      );
      console.log("roles data: ", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching roles data:", error);
    }
  };

  const saveRolesAndPermissions = async (event) => {
    event.preventDefault();

    const restaurantIdList = restaurantList.map((item) => item?.id);
    const userIdList = userList.map((item) => item?.id);
    const screenIdList = screenList.map((item) => item?.id);
    const functionIdList = functionList.map((item) => item?.id);

    let reqObject = {};

    if (userIdList.length <= 0) {
      reqObject = {
        roleId: roleObj.id,
        userId: userIdList,
        creatorId: userId,
        restaurantId: restaurantIdList,
        screenId: screenIdList,
        permissionId: functionIdList,
      };
    } else {
      reqObject = {
        roleId: null,
        userId: userIdList,
        creatorId: userId,
        restaurantId: restaurantIdList,
        screenId: screenIdList,
        permissionId: functionIdList,
      };
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions`,
        reqObject,
      );
      if (response.data) {
        getAllRolesData().then((data) => setRows(data.result));
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }

    // const form = event.target;

    // const selectedRolesId = form.elements.roles.value;
    // const selectedUserId = form.elements.user.value;
    // const selectedRestaurantId = form.elements.restaurant.value;
    // const selectedUiId = form.elements.ui.value;
    // const selectedPermissionId = form.elements.permission.value;
    // const selectedCreatorId = userId;

    // let reqObject = {};

    // if (selectedRolesId === "None") {
    //     const userRoleId = roleIds.find(roleId => roleId.role === role);

    //     reqObject = {
    //         roleId: userRoleId.id,
    //         userId: selectedUserId,
    //         creatorId: selectedCreatorId,
    //         restaurantId: selectedRestaurantId,
    //         screenId: selectedUiId,
    //         permissionId: selectedPermissionId
    //     };

    //     console.log("roles id:", userRoleId.id);
    //     console.log("roles:", reqObject);
    // } else {
    //     reqObject = {
    //         roleId: selectedRolesId,
    //         userId: selectedUserId,
    //         creatorId: selectedCreatorId,
    //         restaurantId: selectedRestaurantId,
    //         screenId: selectedUiId,
    //         permissionId: selectedPermissionId
    //     };
    //     console.log("roles: ", reqObject)
    // }

    // try {
    //     const response = await axios.post(`${process.env.REACT_APP_SECRET}/api/RolesAndPermissions`, reqObject);
    //     if (response.data) {
    //         getAllRolesData().then(data => setRows(data.result));
    //         handleClose();
    //     }
    // } catch (error) {
    //     console.log(error);
    // }
  };

  const handleRoleChange = (event, newValue) => {
    setRoleObj(newValue);
    if (newValue) {
      setUserList([]); // Clear user list if a role is selected
    }
  };

  const handleUserChange = (event, newValue) => {
    setUserList(newValue);
    if (newValue.length > 0) {
      setRoleObj(null); // Clear role if any user is selected
    }
  };

  // const handleRoleChange = (event) => {
  //     setSelectedRole(event.target.value);
  //     // Disable user select when role is selected
  //     setSelectedUser("None");
  // };

  // const handleUserChange = (event) => {
  //     setSelectedUser(event.target.value);
  //     // Disable role select when user is selected
  //     setSelectedRole("None");
  // };

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    const decoded = jwt_decode(token);
    setUserId(decoded.UserId);
    setRestaurantId(decoded.RestaurantId);
    setRole(decoded.UserRole);
  }, []);

  useEffect(() => {
    const getAllRolesData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllUsersRole?userId=${userId}`,
        );
        console.log("roles data: ", response.data);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    };

    if (userId) {
      getAllRolesData().then((data) => {
        setRows(data.result);
        setLoading(false);
      });
    }
  }, [userId]);

  useEffect(() => {
    const getAllModalData = async () => {
      try {
        const roleIds = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllRoles`,
        );
        setRoleIds(roleIds.data);

        const users = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllUserByRestaurantId?restaurantId=${restaurantId}`,
        );
        setUsers(users.data);

        const restaurants = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllRestaurantByUserId?userId=${userId}`,
        );
        setRestaurants(restaurants.data);

        const screens = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllScreens`,
        );
        setScreens(screens.data);

        const functions = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/RolesAndPermissions/GetAllFunction`,
        );
        setFunctions(functions.data);
      } catch (error) {
        console.log(error);
      }
    };

    if (userId && restaurantId) {
      getAllModalData();
    }
  }, [userId, restaurantId]);

  return (
    <div>
      <LoadingView open={loading} close={() => setLoading(false)} />
      <div
        style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "bold" }}
      >
        Permission setup
      </div>
      <div className="permission-btn-container">
        <button onClick={handleOpen}>Add Permission</button>
      </div>
      <TableContainer component={Paper} className="table-container">
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell className="table-cell">
                Role Name
              </StyledTableCell>
              <StyledTableCell className="table-cell" align="center">
                Restaurant Name
              </StyledTableCell>
              <StyledTableCell className="table-cell" align="center">
                UI Name
              </StyledTableCell>
              <StyledTableCell className="table-cell" align="center">
                Permission Details
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 && !loading ? (
              rows?.map((row) => (
                <StyledTableRow key={row.id} className="table-row">
                  <StyledTableCell
                    component="th"
                    scope="row"
                    className="table-row"
                  >
                    {row.roleName}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {row.restaurantName}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.uiName}</StyledTableCell>
                  <StyledTableCell align="center">
                    {row.functionName}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : loading ? (
              <div style={{ padding: "1em", fontSize: "1.1em" }}>
                Loading...
              </div>
            ) : (
              <div className="no-data">No roles data available</div>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="permission__modal-content">
          <div className="permission__modal-close" onClick={handleClose}>
            <img src={close} alt="close button" />
          </div>

          <form
            onSubmit={(event) => saveRolesAndPermissions(event)}
            className="permission-form"
          >
            <div className="select-container">
              <label htmlFor="roles">Roles</label>
              {/* <select name="roles" id="roles" value={selectedRole} onChange={handleRoleChange}>
                                <option value={"None"}>Select a role</option>
                                {
                                    roleIds?.map((role) => <option key={role.id} value={role.id}>{role.role}</option>)
                                }
                            </select> */}
              <Autocomplete
                className="auto-complete"
                id="tags-outlined"
                options={roleIds}
                getOptionLabel={(option) => option.role}
                filterSelectedOptions
                onChange={handleRoleChange}
                value={roleObj}
                disabled={userList.length > 0}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a role"
                    placeholder="Favorites"
                  />
                )}
              />
            </div>

            <div className="select-container">
              <label htmlFor="user">User</label>
              {/* <select name="user" id="user" value={selectedUser} onChange={handleUserChange}>
                                <option value={"None"}>Select a user</option>
                                {
                                    users?.map((user) => <option key={user.id} value={user.id}>{user.userName}</option>)
                                }
                            </select> */}
              <Autocomplete
                className="auto-complete"
                multiple
                id="tags-outlined"
                options={users}
                getOptionLabel={(option) => option.userName}
                filterSelectedOptions
                onChange={handleUserChange}
                value={userList}
                disabled={roleObj !== null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a user"
                    placeholder="Favorites"
                  />
                )}
              />
            </div>

            <div className="select-container">
              <label htmlFor="restaurant">Restaurant</label>
              {/* <select name="restaurant" id="restaurant">
                                <option value={"None"}>Select a restaurant</option>
                                {
                                    restaurants?.map((restaurant) => <option key={restaurant.id} value={restaurant.id}>{restaurant.restaurantName}</option>)
                                }
                            </select> */}
              <Autocomplete
                className="auto-complete"
                multiple
                id="tags-outlined"
                options={restaurants}
                getOptionLabel={(option) => option.restaurantName}
                filterSelectedOptions
                onChange={(event, newValue) => setRestaurantList(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a restaurant"
                    placeholder="Favorites"
                  />
                )}
              />
            </div>

            <div className="select-container">
              <label htmlFor="ui">UI</label>
              {/* <select name="ui" id="ui">
                                <option value={"None"}>Select a UI</option>
                                {
                                    screens?.map((screen) => <option key={screen.id} value={screen.id}>{screen.uiName}</option>)
                                }
                            </select> */}
              <Autocomplete
                className="auto-complete"
                multiple
                id="tags-outlined"
                options={screens}
                getOptionLabel={(option) => option.uiName}
                filterSelectedOptions
                onChange={(event, newValue) => setScreenList(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a UI"
                    placeholder="Favorites"
                  />
                )}
              />
            </div>

            <div className="select-container">
              <label htmlFor="permission">Permission</label>
              {/* <select name="permission" id="permission">
                                <option value={"None"}>Select a permission</option>
                                {
                                    functions?.map((fnc) => <option key={fnc.id} value={fnc.id}>{fnc.functionName}</option>)
                                }
                            </select> */}
              <Autocomplete
                className="auto-complete"
                multiple
                id="tags-outlined"
                options={functions}
                getOptionLabel={(option) => option.functionName}
                filterSelectedOptions
                onChange={(event, newValue) => setFunctionList(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a permission"
                    placeholder="Favorites"
                  />
                )}
              />
            </div>

            <div className="save-btn-container">
              <input value="Save" type="submit" />
              {/* <button>Save</button> */}
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default RolesAndPermissions;
